import React from 'react';
import PropTypes from 'prop-types';

// Components
import RegexInput from './regex';


export default class DurationInput extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    onChange: PropTypes.func.isRequired
  };

  constructor() {
    super();
    this.increase = this.increase.bind(this);
    this.decrease = this.decrease.bind(this);
  }

  increase(e) {
    // Clicking on an input group addon selects the form element, which we don't want to do when
    // incrementing/decrementing the duration value, so we cancel the event if it exists
    if (e) e.preventDefault();

    const currentValue = Number(this.props.value);
    // If the last value was already a multiple of .25, add .25 to the current value. Otherwise,
    // round up to the nearest multiple of .25
    const closestDuration = Math.ceil(currentValue / 0.25) * 0.25;
    const nextDuration = closestDuration === currentValue ? currentValue + 0.25 : closestDuration;
    this.props.onChange(nextDuration);
  }

  decrease(e) {
    // Clicking on an input group addon selects the form element, which we don't want to do when
    // incrementing/decrementing the duration value, so we cancel the event if it exists
    if (e) e.preventDefault();

    const currentValue = Number(this.props.value);
    // If the last value was already a multiple of .25, subtract .25 from the current value. Otherwise,
    // round down to the nearest multiple of .25
    const closestDuration = Math.floor(currentValue / 0.25) * 0.25;
    let nextDuration = closestDuration === currentValue ? currentValue - 0.25 : closestDuration;
    if (nextDuration < 0) nextDuration = 0; // nextDuration should never be negative
    this.props.onChange(nextDuration);
  }

  render() {
    return (
      <div className="input-group">
        <RegexInput
          {...this.props}
          autoComplete="off"
          regex={/^(\d+(\.\d{0,2})?|\.\d{0,2})$/}
          onKeyDown={(e) => {
            if (e.key === 'ArrowUp') {
              this.increase();
            } else if (e.key === 'ArrowDown') {
              this.decrease();
            }
          }}
        />
        <span className="input-group-append increment-button-group">
          <div onClick={this.decrease} className="increment-button input-group-text">
            -
          </div>
          <div onClick={this.increase} className="increment-button input-group-text">
            +
          </div>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/inputs/duration.js